import React from "react";
import { useFeatureFlagValues } from "../hooks/use-feature-flag-values";
export var FeatureFlagContext = React.createContext({ flags: [], loading: true });
/**
 * A React hook to access the values of the provided feature flags.
 * You should use this instead of a `<FeatureFlagConsumer>` component if you are ready
 * to use hooks in your application.
 */
export var useFeatureFlagContext = function () { return React.useContext(FeatureFlagContext); };
export var FeatureFlagConsumer = FeatureFlagContext.Consumer;
export var FeatureFlagContextProvider = function (props) {
    var children = props.children, apiBaseUrl = props.apiBaseUrl, accessToken = props.accessToken, tenantId = props.tenantId, flags = props.flags;
    var _a = useFeatureFlagValues({
        apiBaseUrl: apiBaseUrl,
        accessToken: accessToken,
        tenantId: tenantId,
        flags: flags,
    }), flagValueResults = _a.flags, loading = _a.loading;
    var context = {
        flags: flagValueResults,
        loading: loading,
    };
    return (React.createElement(FeatureFlagContext.Provider, { value: context }, children));
};
//# sourceMappingURL=feature-flag-context.js.map